// extracted by mini-css-extract-plugin
module.exports = {"root":"root__yBuxQ","item":"item__2XZAO"};